// Auto-loaded by I18nContext. Add a new language by creating a sibling file
// (e.g. de.js), then registering it in this barrel. Keys missing from a
// language fall back to English via the t() helper.
import en from './en';
import lv from './lv';
import fr from './fr';
import es from './es';
import it from './it';
import pt from './pt';
import et from './et';
import lt from './lt';
import pl from './pl';
import uk from './uk';
import ru from './ru';

export const translations = { en, lv, fr, es, it, pt, et, lt, pl, uk, ru };

// Map a canonical notification language code (13 codes: may include regional
// variants like pt-BR / es-419 and languages with no UI bundle like pl/uk/ru)
// to the closest available UI translation bundle. Falls back to English so the
// interface always renders. This is what lets ONE language setting drive both
// the notification language (canonical, stored on the backend) and the web UI.
export function uiLangFor(code) {
  if (!code) return 'en';
  if (translations[code]) return code;                 // exact bundle (e.g. 'pt')
  const base = String(code).split('-')[0].toLowerCase();
  if (translations[base]) return base;                 // pt-BR → pt, es-419 → es
  return 'en';                                          // pl/uk/ru → English UI
}

// Display labels for the language picker. Native endonyms + alphabetised by
// the English name (the requirement was to present them alphabetically).
export const LANG_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'et', label: 'Eesti' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'lv', label: 'Latviešu' },
  { code: 'lt', label: 'Lietuvių' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt', label: 'Português' },
  { code: 'uk', label: 'Українська' },
  { code: 'ru', label: 'Русский' },
];
